/* eslint-disable max-classes-per-file */
import { MInspector } from '@Models/client/inspection.model'
import { CommonService } from '@Services/common.service'

export interface ICommon {
    title: string
    url: string
}

export interface IPageHeaderActions {
    name?: string
    value?: string
    variant?: any
    disabled?: boolean
    className?: string
    isLoading?: boolean
}

export type ISelectOptions = IPageHeaderActions

export interface ICommonProduct {
    checkbox?: boolean
    checked?: boolean
    imageUrl?: string
    name?: string
    make?: string | any
    model?: string | any
    dueDate?: string
    paidDate?: string
    fee?: string
    balance?: string
    serialCode?: string
    id?: string
    status?: string
    itemSubscription?: any
    inspectionSchedule?: any
    component?: string
}

export class MSubscription {
    createdAt: string

    createdBy: string

    duration: string

    endedAt: string

    id: string

    issuedAt: null

    itemId: string

    startedAt: string

    status: string

    subscriptionPlanId: string

    unitPrice: string

    updatedAt: string

    updatedBy: string

    userId: string

    totalAmount: string | number

    constructor(subscription: any) {
        this.createdAt = subscription?.createdAt
        this.createdBy = subscription?.createdBy
        this.duration = subscription?.duration
        this.endedAt = subscription?.endedAt
        this.id = subscription?.id
        this.issuedAt = subscription?.issuedAt
        this.startedAt = subscription?.startedAt
        this.status = subscription?.status
        this.subscriptionPlanId = subscription?.subscriptionPlanId
        this.unitPrice = subscription?.unitPrice
        this.updatedAt = subscription?.updatedAt
        this.updatedBy = subscription?.updatedBy
        this.userId = subscription?.userId
        this.itemId = subscription?.itemId
        this.totalAmount = subscription?.totalAmount
    }
}

export class MTransactionDetail {
    address: string

    businessName: string

    city: string

    cityName: string

    id: string

    issuedAt: string

    itemId: string

    orderedAt: string

    state: string

    stateName: string

    status: string

    zipCode: string

    fflId: string

    constructor(transactionDetail: any) {
        this.address = transactionDetail?.address
        this.businessName = transactionDetail?.businessName
        this.city = transactionDetail?.city?.code
        this.cityName = transactionDetail?.city?.name
        this.id = transactionDetail?.id
        this.issuedAt = CommonService.dateFormat(transactionDetail?.issuedAt)
        this.itemId = transactionDetail?.itemId
        this.orderedAt = CommonService.dateFormat(transactionDetail?.orderedAt)
        this.state = transactionDetail?.state?.code
        this.stateName = transactionDetail?.state?.name
        this.status = transactionDetail?.status
        this.zipCode = transactionDetail?.zipCode
        this.fflId = transactionDetail?.fflId
    }
}

export class MInspection {
    code: string

    id: string

    scheduledAt: string

    status: string

    constructor(schedule: MInspection) {
        this.code = schedule?.code
        this.id = schedule?.id
        this.scheduledAt = schedule?.scheduledAt
        this.status = schedule?.status
    }
}

export class MCommonProduct {
    id: string

    name: string

    serialCode: string

    make: string

    model: string

    dueDate: any

    paidDate: any

    fee: string

    checkbox: boolean

    imageUrl: string

    checked: boolean

    modelName: string

    makeName: string

    caliber: string

    firearmTypeName: string

    itemSubscription: MSubscription

    transactionDetail: MTransactionDetail

    status: string

    type: string

    inspectionSchedule: MInspection

    component: string

    constructor(firearm: any) {
        this.id = firearm?.id
        this.name = firearm?.model?.name
        this.serialCode = firearm?.serialCode
        this.make = firearm?.make?.code
        this.model = firearm?.model?.code
        this.dueDate =
            firearm?.status === 'PENDING'
                ? CommonService.dateFormat(firearm?.itemSubscription?.startedAt)
                : CommonService.dateFormat(firearm?.itemSubscription?.endedAt)
        this.paidDate = CommonService.dateFormat(
            firearm?.itemSubscription?.issuedAt
        )
        this.fee = firearm?.itemSubscription?.unitPrice
        this.checkbox = firearm?.itemSubscription?.status === 'PENDING'
        this.imageUrl =
            firearm?.imageUrl ||
            (firearm?.files?.length && firearm?.files[0]?.fileUrl)
        this.checked = !!firearm?.checked
        this.modelName = firearm?.model?.name
        this.makeName = firearm?.make?.name
        this.caliber = firearm?.caliber
        this.firearmTypeName = firearm?.safeType?.name
        this.itemSubscription = new MSubscription(firearm?.itemSubscription)
        this.transactionDetail = new MTransactionDetail(
            firearm?.transactionDetail
        )
        this.status = firearm?.status
        this.type = firearm?.type
        this.inspectionSchedule = new MInspection(firearm?.inspectionSchedule)
        this.component = firearm?.component || ''
    }
}

export interface IMetaData {
    limit?: number
    offset?: number
    total?: number
}

export interface ICommonQuery extends IMetaData {
    metaData?: IMetaData
    search?: string
    status?: string
    type?: string
    codes?: string
    parentCode?: string
    latitude?: number
    longitude?: number
    country?: string
    state?: string
    city?: string
    page?: number
}

export interface IUpdate<T> {
    id: string
    payload?: T
}

export class MUserInfo extends MInspector {}

// table
export interface ITableHeaders {
    name: string
    key: string
    metadata?: IMetaData
    align?: 'left' | 'right' | 'inherit' | 'center' | 'justify'
    formatType?: // for format date time, hours
    'date' | 'no' | 'image' | 'currency'
    style?: any
    // check if header is sortable ay asc and desc
    className?: string
    render?: (index: number, data: any) => void
}
